/****************************************************
 * Module Name:  editEmployeeModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import UserProxy from "../../utility/proxy/manager/userProxy";
import Select from "react-select";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import "bootstrap/dist/css/bootstrap.min.css";
import DesignationProxy from "../../utility/proxy/manager/designationProxy";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { MultiSelect } from "../common/reactSelectWithSelectAll";
import EmployeeProxy from "../../utility/proxy/manager/employeeProxy";
import { LoadingButton } from "@mui/lab";
import logo from "../../images/pansuriya.jpg";
import SaveIcon from '@mui/icons-material/Save';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const setPropSourceDataofCustomer = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.customerid, label: item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

const setPropSourceDataofBroker = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.brokerid, label: item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

const fullOptionToCustomerValue = (employeeId, selectedData) => {
  let employeid = employeeId;
  let newArr = [];
  selectedData.map((option) => {
    newArr.push({ employeid, customerid: option.value });
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

const fullOptionToBrokerValue = (employeeId, selectedData) => {
  let employeid = employeeId;
  let newArr = [];
  selectedData.map((option) => {
    newArr.push({ employeid, brokerid: option.value });
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

export default class EditEmployeeModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newusername: this.props.editOperation
        ? this.props.sourceData.username
        : "",
      newUserType:
        this.props.sourceData !== undefined
          ? this.props.editOperation ||
            (!this.props.editOperation && this.props.sourceData.usertype)
            ? {
              value: this.props.sourceData.usertype,
              label: this.props.sourceData.usertype,
            }
            : { value: 0, label: "Error" }
          : { value: 0, label: "Error" },
      newfirst_name: this.props.editOperation
        ? this.props.sourceData.first_name
        : "",
      newmiddle_name: this.props.editOperation
        ? this.props.sourceData.middle_name
        : "",
      newlast_name: this.props.editOperation
        ? this.props.sourceData.last_name
        : "",
      newdesignation: this.props.editOperation
        ? this.props.sourceData.designation
        : "",
      newemployeeid: this.props.editOperation
        ? this.props.sourceData.employeeid
        : "",
      newlocationid: this.props.editOperation
        ? this.props.sourceData.locationid
        : "",
      newfullLocation: this.props.editOperation
        ? {
          value: this.props.sourceData.locationid,
          label: this.props.sourceData.location,
        }
        : { value: 0, label: "Error" },
      newAssignedCustomer: this.props.editOperation
        ? setPropSourceDataofCustomer(this.props.sourceData.employecustomer)
        : "",
      newAssignedBroker: this.props.editOperation
        ? setPropSourceDataofBroker(this.props.sourceData.employebroker)
        : "",
      newdeleted: this.props.editOperation
        ? this.props.sourceData.deleted
        : false,
      newdisabled: this.props.editOperation
        ? this.props.sourceData.disabled
        : false,
      newspecialuser: this.props.editOperation
        ? this.props.sourceData.specialuser
        : false,
      newgrade: this.props.editOperation
        ? this.props.sourceData.grade
        : "",
      newgstno: this.props.editOperation
        ? this.props.sourceData.gstinno
        : "",
      newpanno: this.props.editOperation
        ? this.props.sourceData.panno
        : "",
      newEmail: this.props.editOperation ? this.props.sourceData.email : "",
      newPhone: this.props.editOperation ? this.props.sourceData.phone : "",
      newCreated: this.props.editOperation ? this.props.sourceData.created : "",
      newCreatedBy: this.props.editOperation ? this.props.sourceData.createdby : "",
      newCompanyName: this.props.editOperation
        ? this.props.sourceData.companyname
        : "",
      showError: false,

      validateUserPresentSpinner: false,
      showValidationMessage: false,
      userNameAvailable: true,

      fullLocation: [],
      fullLocationOptions: [],
      showLocationLoadSpinner: true,

      brokerOptions: [],
      showBrokerLoadSpinner: true,

      customerOptions: [],
      showCustomerLoadSpinner: true,

      allUserType: [],

      designationOptions: [],
      showDesignationLoadSpinner: true,

      userNameValidationError: "",
      firstNameValidationError: "",

      customerInputValue: "",
      debouncedCustomerInputValue: "",

      showUserDetailModal: false,
      userDetailContext: ""
    };
    this.getAllLocationList(false);
    this.getAllDesignationList(false);
    this.getAllBroker(false);
    this.getAllCustomer(false);
    if (this.props.sourceData === undefined) {
      this.getUserById();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleDebounce("customerInputValue", "debouncedCustomerInputValue", prevState, this.state);
  }

  handleDebounce(inputState, debouncedState, prevState, currentState) {
    if (prevState[inputState] !== currentState[inputState]) {
      this.setState({ [debouncedState]: currentState[inputState] });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.customerInputValueTimeoutId);
  }

  getFilteredUserOptions(debouncedValue) {
    if (!debouncedValue) {
      return this.state.customerOptions.slice(0, 100);
    }
    return this.state.customerOptions
      .filter(option =>
        option.label.toLowerCase().includes(debouncedValue.toLowerCase())
      )
      .slice(0, 500);
  }


  getUserById = () => {
    EmployeeProxy.GetSingleEmployeeById(this.props.userId, (response) =>
      this.setState({
        newusername: response.username,
        newUserType: { value: response.usertype, label: response.usertype },
        newfirst_name: response.first_name,
        newmiddle_name: response.middle_name,
        newlast_name: response.last_name,
        newdesignation: response.designation,
        newemployeeid: response.employeeid,
        newlocationid: response.locationid,
        newfullLocation: {
          value: response.locationid,
          label: response.location + " | " + response.country,
        },
        newAssignedCustomer: setPropSourceDataofCustomer(
          response.employecustomer
        ),
        newAssignedBroker: setPropSourceDataofBroker(response.employebroker),
        newdeleted: response.deleted,
        newdisabled: response.disabled,
        newspecialuser: response.specialuser,
        newgrade: response.grade,
        newgstno: response.gstinno,
        newpanno: response.panno,
        newEmail: response.email,
        newPhone: response.phone,
        newCreated: response.created,
        newCreatedBy: response.createdby,
        newCompanyName: response.companyname,
      })
    );
  };

  getAllBroker = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showBrokerLoadSpinner: true });
    UserProxy.GetAllBrokerMini((response) =>
      this.setAllBrokerData(response)
    );
  };

  setAllBrokerData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.username };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      brokerOptions: optionsArray,
      newAssignedBroker:
        this.state.newAssignedBroker === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newAssignedBroker,
      showBrokerLoadSpinner: false,
    });
  };

  getAllCustomer = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showCustomerLoadSpinner: true });
    UserProxy.GetAllCustomerMini((response) =>
      this.setAllCustomerData(response)
    );
  };

  setAllCustomerData = (response) => {
    const sortedResponse = Utility.sortFn(response, "username");
    let optionsArray = [];
    sortedResponse.map((data) => {
      let option = { value: data.id, label: data.username };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      customerOptions: optionsArray,
      newAssignedCustomer:
        this.state.newAssignedCustomer === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newAssignedCustomer,
      showCustomerLoadSpinner: false,
    });
  };

  getAllLocationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showLocationLoadSpinner: true });
    LocationProxy.GetAllLocationDetail((response) =>
      this.setAllLocationData(response)
    );
  };

  setAllLocationData = (response) => {
    // this.setAllUserType();
    let cOptions = [];
    let nnewfullLocation = this.state.newfullLocation;
    response.map((data) => {
      let iOption = { value: data.id, label: data.name + " | " + data.country };
      cOptions.push(iOption);

      if (data.id === this.state.newfullLocation.value)
        nnewfullLocation = iOption;
      return true;
    });

    //During new creation option select first one as default
    if (nnewfullLocation.value === 0 && cOptions.length > 0)
      nnewfullLocation = cOptions[0];

    this.setState({
      fullLocation: response,
      fullLocationOptions: cOptions,
      newfullLocation: nnewfullLocation,
      showLocationLoadSpinner: false,
    });
  };

  getAllDesignationList = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showDesignationLoadSpinner: true });
    DesignationProxy.GetAllDesignation((response) =>
      this.setAllDesigationData(response)
    );
  };

  setAllDesigationData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.name, label: data.name };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      designationOptions: optionsArray,
      newdesignation:
        this.state.newdesignation === "" && optionsArray.length > 0
          ? optionsArray[0].value
          : this.state.newdesignation,
      showDesignationLoadSpinner: false,
    });
  };

  handleSave = () => {
    let employeeId =
      this.props.sourceData === undefined
        ? this.props.userId
        : this.props.sourceData.id;
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      username: this.state.newusername,
      first_name: this.state.newfirst_name,
      middle_name: this.state.newmiddle_name,
      last_name: this.state.newlast_name,
      designation: this.state.newdesignation,
      employeeid: this.state.newemployeeid,
      employebroker: fullOptionToBrokerValue(
        employeeId,
        this.state.newAssignedBroker
      ),
      employecustomer: fullOptionToCustomerValue(
        employeeId,
        this.state.newAssignedCustomer
      ),
      specialuser: this.state.newspecialuser,
      locationid: this.state.newfullLocation.value,
      deleted: this.state.newdeleted,
      disabled: this.state.newdisabled,
      grade: this.state.newgrade,
      gstinno: this.state.newgstno,
      panno: this.state.newpanno,
      usertype: this.state.newUserType.value,
      email: this.state.newEmail,
      phone: this.state.newPhone,
      created: this.state.newCreated,
      companyname: this.state.newCompanyName,
      createdby: this.state.newCreatedBy,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(employeeId, data))
          this.props.handleSave(employeeId, data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(employeeId, data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newfirst_name.length === 0)
      return true;

    if (
      this.props.sourceData === undefined &&
      this.state.newfirst_name.length === 0
    )
      return true;

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Edit Employee validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        {this.state.showUserDetailModal && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(1px)",
                zIndex: 1299,
              }}
            />
            <UserDetailModal
              show={true}
              handleClose={() => this.setState({ showUserDetailModal: false })}
              handleSelect={(selectedOption) => {
                if (this.state.userDetailContext === "B") {
                  const selectedData = this.state.brokerOptions.filter(opt => selectedOption.includes(opt.value));
                  this.setState({
                    userDetailContext: "",
                    showUserDetailModal: false,
                    newAssignedBroker: selectedData,
                  });
                } else if (this.state.userDetailContext === "C") {
                  const selectedData = this.state.customerOptions.filter(opt => selectedOption.includes(opt.value));
                  this.setState({
                    userDetailContext: "",
                    showUserDetailModal: false,
                    newAssignedCustomer: selectedData,
                  });
                }
              }}
              userids={this.state.userDetailContext === "B" ?
                (this.state.brokerOptions.filter(opt => opt.value !== "*")).map(cust => cust.value) :
                (this.state.customerOptions.filter(opt => opt.value !== "*")).map(cust => cust.value)}
              selectedIds={
                this.state.userDetailContext === "B"
                  ? this.state.newAssignedBroker.length > 0 ? this.state.newAssignedBroker.map(i => i.value) : []
                  : this.state.newAssignedCustomer.length > 0 ? this.state.newAssignedCustomer.map(i => i.value) : []
              }
              usertype={this.state.userDetailContext}
              loading={this.state.showUserDetailModal}
              isMulti={true}
            />
          </>
        )}

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} size="lg" enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;Edit Employee
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box
              sx={{
                width: "100%",
                "& .css-2vawn2-MuiTypography-root": {
                  alignSelf: "center",
                },
              }}
            >
              {this.props.editOperation && (
                <Box sx={{ display: "flex", width: "100%" }}>
                  <Typography sx={{ width: "24%" }}>User Id</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {this.props.sourceData.id}
                  </Typography>
                </Box>
              )}
              {!this.props.sourceData && (
                <Box sx={{ display: "flex", width: "100%" }}>
                  <Typography sx={{ width: "24%" }}>User Id</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {this.props.userId}
                  </Typography>
                </Box>
              )}
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "24%" }}>Username</Typography>
                <Typography sx={{ fontWeight: "bold" }}>
                  {this.state.newusername}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "30%" }}>
                  First Name <sup style={{ color: "red" }}>*</sup>
                </Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="First Name (required)"
                  placeholder="Enter First Name"
                  value={this.state.newfirst_name}
                  onChange={(e) =>
                    this.setState({
                      newfirst_name: e.target.value.trim(),
                      firstNameValidationError: Utility.CheckIsPresent(
                        e.target.value
                      )
                        ? ""
                        : "First Name Cannot be Empty ",
                    })
                  }
                  helperText={this.state.firstNameValidationError}
                  error={this.state.firstNameValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "30%" }}>Middle Name</Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="Middle Name"
                  placeholder="Enter Middle Name"
                  value={this.state.newmiddle_name}
                  onChange={(e) =>
                    this.setState({ newmiddle_name: e.target.value.trim() })
                  }
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ width: "30%" }}>Last Name</Typography>
                <TextField
                  margin="normal"
                  size="small"
                  fullWidth
                  label="Last Name"
                  placeholder="Enter Last Name"
                  value={this.state.newlast_name}
                  onChange={(e) =>
                    this.setState({ newlast_name: e.target.value.trim() })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "24%", alignSelf: "center" }}>
                  User Type
                </Typography>
                <Typography sx={{ fontWeight: "600" }}>
                  {Constants.USER_TYPE[this.state.newUserType.value]}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "24%", alignSelf: "center" }}>
                  Designation
                </Typography>
                <Box sx={{ width: "76%" }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.designationOptions.find(
                      (iDesig) => iDesig.value === this.state.newdesignation
                    )}
                    isSearchable={true}
                    name="Designation"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.state.designationOptions}
                    onChange={(selectedOption) =>
                      this.setState({
                        newdesignation: selectedOption.value,
                      })
                    }
                  />
                </Box>
                {this.state.showDesignationLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllDesignationList(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography sx={{ width: "30%" }}>Employee Id</Typography>
                <TextField
                  size="small"
                  fullWidth
                  label="Employee Id"
                  placeholder="Enter Employee Id"
                  value={this.state.newemployeeid}
                  onChange={(e) =>
                    this.setState({ newemployeeid: e.target.value })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Broker
                </Typography>
                <Box sx={{ width: "76%", display: "flex", alignItems: "center" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <MultiSelect
                      options={this.state.brokerOptions}
                      value={this.state.newAssignedBroker}
                      onChange={(e) => this.setState({ newAssignedBroker: e })}
                      label={"All Brokers"}
                    />
                  </Box>
                  <Tooltip title="View More Data">
                    <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                      <OpenInNewIcon
                        fontSize="medium"
                        onClick={() => this.setState({ showUserDetailModal: true, userDetailContext: "B" })}
                        color="action"
                      />
                    </span>
                  </Tooltip>
                  {this.state.showBrokerLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: "3px", ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllBroker(true)}
                        sx={{ cursor: "pointer", mt: 1 }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Customer
                </Typography>
                <Box sx={{ width: "76%", display: "flex", alignItems: "center" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newAssignedCustomer}
                      isSearchable={true}
                      isMulti
                      closeMenuOnSelect={false}
                      name="All Customers"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.getFilteredUserOptions(this.state.debouncedCustomerInputValue)}
                      onChange={(e) => this.setState({ newAssignedCustomer: e })}
                      inputValue={this.state.customerInputValue}
                      onInputChange={(inputValue) => this.setState({ customerInputValue: inputValue })}
                    />
                  </Box>
                  <Tooltip title="View More Data">
                    <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                      <OpenInNewIcon
                        fontSize="medium"
                        onClick={() => this.setState({ showUserDetailModal: true, userDetailContext: "C" })}
                        color="action"
                      />
                    </span>
                  </Tooltip>
                  {this.state.showCustomerLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: "3px", ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllCustomer(true)}
                        sx={{ cursor: "pointer", mt: 1 }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "24%", alignSelf: "center" }}>
                  Location
                </Typography>

                <Box sx={{ width: "76%" }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    value={this.state.newfullLocation}
                    isSearchable={true}
                    name="Location"
                    options={this.state.fullLocationOptions}
                    onChange={(selectedOption) =>
                      this.setState({ newfullLocation: selectedOption })
                    }
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                  />
                </Box>

                {this.state.showLocationLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllLocationList(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 1 }}>
                <Box sx={{ width: "24%" }}></Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newdeleted}
                        onChange={(e) =>
                          this.setState({
                            newdeleted: !this.state.newdeleted,
                          })
                        }
                      />
                    }
                    label="Deleted"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.8rem",
                      },
                    }}
                  />
                </Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.newdisabled}
                        onChange={(e) =>
                          this.setState({
                            newdisabled: !this.state.newdisabled,
                          })
                        }
                      />
                    }
                    label="Disabled"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.8rem",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            {this.props.saveButton ? (
              <Box sx={{
                "& .Mui-disabled": {
                  backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                  color: "rgba(0, 0, 0, 0.26) !important"
                }
              }}>
                <LoadingButton
                  variant="contained"
                  loading={this.props.loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  onClick={() => this.handleSave()}
                  disabled={this.buttonDisable()}
                  sx={{ mr: 1 }}
                >
                  Save
                </LoadingButton>
              </Box>
            ) : null}
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
